import { BrowserStorageType } from "../config/general.config.ts"
import { UtilHelper } from "./util.helper"

/**
 * Class for working with localStorage and sessionStorage inside application
 */
export class BrowserStorageHelper {
    /**
     * Set value in local storage
     */
    static set(
        key: string,
        data: any,
        browserStorageType: BrowserStorageType = BrowserStorageType.localStorage,
    ) {
        try {
            window[browserStorageType].setItem(
                BrowserStorageHelper.buildKey(key),
                UtilHelper.isObject(data) ? JSON.stringify(data) : data,
            )
        } catch (e) {}
    }

    /**
     * Get value from local storage
     */
    static get<ReturnType = any>(
        key: string,
        defaultValue?: ReturnType | null,
        browserStorageType: BrowserStorageType = BrowserStorageType.localStorage,
    ): ReturnType | null {
        let item: any = null
        defaultValue = typeof defaultValue === "undefined" ? null : defaultValue

        try {
            item = window[browserStorageType].getItem(
                BrowserStorageHelper.buildKey(key),
            ) as any

            if (item === null) {
                return defaultValue
            }

            return JSON.parse(item)
        } catch (e) {
            return item === null ? defaultValue : item
        }
    }

    /**
     * Remove value from local storage
     */
    static remove(
        key: string,
        browserStorageType: BrowserStorageType = BrowserStorageType.localStorage,
    ) {
        try {
            window[browserStorageType].removeItem(
                BrowserStorageHelper.buildKey(key),
            )
        } catch (e) {}
    }

    /**
     * Update value in local storage
     */
    static update(key: string, data: any) {
        BrowserStorageHelper.remove(key)
        BrowserStorageHelper.set(key, data)
    }

    /**
     * Format local storage key based on config
     */
    private static buildKey(key: string): string {
        return `nirvana-${key}`
    }
}
